var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 4.00016V2.66683C3.33203 2.31321 3.47251 1.97407 3.72256 1.72402C3.9726 1.47397 4.31174 1.3335 4.66536 1.3335H7.33203C7.68565 1.3335 8.02479 1.47397 8.27484 1.72402C8.52489 1.97407 8.66536 2.31321 8.66536 2.66683V4.00016M10.6654 4.00016V13.3335C10.6654 13.6871 10.5249 14.0263 10.2748 14.2763C10.0248 14.5264 9.68565 14.6668 9.33203 14.6668H2.66536C2.31174 14.6668 1.9726 14.5264 1.72256 14.2763C1.47251 14.0263 1.33203 13.6871 1.33203 13.3335V4.00016H10.6654Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFileicon);
export default __webpack_public_path__ + "static/media/delete-file.icon.a2b5eb263510f38acd04ec2db2410b31.svg";
export { ForwardRef as ReactComponent };